const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

// Given an ordered array of coordinates (driver's current position first,
// then each stop in order), fetches the actual driving route from Mapbox's
// Directions API — used to draw the route line on the map, and to get
// a real driving distance/duration (not just straight-line).
export async function getDrivingRoute(orderedCoords) {
  // Mapbox expects "lng,lat" pairs joined by ";"
  const coordsString = orderedCoords.map((c) => `${c.lng},${c.lat}`).join(';');

  const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${coordsString}?geometries=geojson&overview=full&access_token=${MAPBOX_TOKEN}`;

  const response = await fetch(url);
  const data = await response.json();

  if (data.routes && data.routes.length > 0) {
    const route = data.routes[0];
    return {
      geometry: route.geometry, // GeoJSON LineString, used to draw the route on the map
      distanceMiles: (route.distance / 1609.34).toFixed(1),
      durationMinutes: Math.round(route.duration / 60),
    };
  }

  return null;
}